import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';

const get = (client, { venueId, staffId }) => {
  const endpoint = URLS.staffAndEquipment.getServices(venueId, staffId);

  return client.get(endpoint).then(transformV2ClientResponse);
};

const handler = ({ httpClient }, { venueId, staffId }) => {
  return get(httpClient, { venueId, staffId });
};
export default makeEntityScaffold('SAGA.API.STAFF_AND_EQUIPMENT', handler, {
  defaultKey: (_, { staffId = '' }) => staffId,
});
